import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { MapEvents } from "~app/features/planera/events/map-events";
import { PlaneraKartaEventService } from "~app/features/planera/planera-karta/planera-karta-event.service";
import { ButtonComponent } from "../../../../button/button.component";
import { IMapGeometry, IMapSettings } from "../../../map.settings";

@Component({
    selector: "rask-geometries-list",
    templateUrl: "./geometries-list.component.html",
    styleUrls: ["./geometries-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class GeometriesListComponent implements OnInit {
    activeGeometries: any[] = [];
    @Input() mapSettings: IMapSettings;

    private readonly planeraKartaEventService = inject(PlaneraKartaEventService);

    click(geometry: IMapGeometry) {
        this.planeraKartaEventService.emit(MapEvents.geometriMenuSelected, geometry);
    }

    getActiveGeometries() {
        const activeGeometries = this.mapSettings?.drawLayers?.filter(l => l.visible && l.showGeometriesMenu && l.geometries.length > 0)
            .map(l => l.geometries)
            .reduce((total, geo) => total.concat(geo), []);
        return activeGeometries ?? [];
    }

    mouseout(geometry: IMapGeometry) {
        this.planeraKartaEventService.emit(MapEvents.geometriMenuHover, null);
    }

    mouseover(geometry: IMapGeometry) {
        this.planeraKartaEventService.emit(MapEvents.geometriMenuHover, geometry);
    }

    ngOnInit(): void {
        this.activeGeometries = this.getActiveGeometries();
    }
}
